import { getRegionalApiEndpoints } from '../../../globals/regional-api';

export const isUserSSO = (username: string) =>
  fetch(
    `${getRegionalApiEndpoints().sso}/entry_points?email=${encodeURIComponent(
      username,
    )}`,
  );
